import { render, staticRenderFns } from "./Frais.vue?vue&type=template&id=384dbc9b&scoped=true&"
import script from "./Frais.vue?vue&type=script&lang=js&"
export * from "./Frais.vue?vue&type=script&lang=js&"
import style0 from "./Frais.vue?vue&type=style&index=0&id=384dbc9b&scoped=true&lang=scss&"
import style1 from "./Frais.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384dbc9b",
  null
  
)

export default component.exports